// extracted by mini-css-extract-plugin
module.exports = {"layout-container":"Layout_layout-container___i7F8","main-container":"Layout_main-container__41AcV","no-margin":"Layout_no-margin__0Zbin"};